import React from "react";
import { Link } from "react-router-dom";

const menu = [
  {title: 'Home', href: '/'},
  {title: 'About', href: 'about'},
  {title: 'Destinations', href: 'destinations'},
  {title: 'Contact', href: 'contact'}
]

const MobileMenu = ({ setShowBurger }) => {
  return (
    <>
      <div className="flex flex-col h-full justify-between">
        <div>
          <div className='lg:flex gap-x-[25px] space-y-[25px]'>
            {menu.map((item, index) => {
              return (
                <div key={index}>
                  <Link onClick={() => setShowBurger(false)} to={item.href}>
                    <div>
                      <p className="text-black">{item.title}</p>
                    </div>
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  )
}

export default MobileMenu
